import React from "react";
import { Grid2 } from "@mui/material";

import { acceleratorCardsMock } from "../model/constants";

import { AcceleratorCard } from "./AcceleratorCard/AcceleratorCard";

export const AcceleratorCards: React.FC = () => {
  return (
    <Grid2
      container
      columns={1}
      spacing={4}
      direction="row"
      alignItems="stretch"
    >
      {acceleratorCardsMock.map((projectCard) => (
        <AcceleratorCard
          key={projectCard.title}
          title={projectCard.title}
          description={projectCard.description}
          image={projectCard.image}
        />
      ))}
    </Grid2>
  );
};
